// extracted by mini-css-extract-plugin
export default {"container":"ContentBlock_container__2Od4l","center":"ContentBlock_center__MgZ6P"};